module.exports = __webpack_public_path__ + "assets/ab5211c370ac12be9e88f04cd3da8373.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/bg/video.webm
// module id = 362
// module chunks = 1